var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"mr-2",attrs:{"cols":"auto"}},[_c('v-menu',{attrs:{"offset-y":"","left":"","value":_vm.menuIsShowed,"min-width":"200"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","disabled":_vm.disabled},on:{"click":function($event){_vm.menuIsShowed = 'trucy'}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }